import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { PayoutReportDetail, setFilters } from '@mews-commander/modules/src/modules/payout';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/PayoutReport/Detail/$id')({
    validateSearch: z.object({
        startUtc: z.string().optional(),
        endUtc: z.string().optional(),
    }),
    loaderDeps: ({ search: { startUtc, endUtc } }) => ({ startUtc, endUtc }),
    loader: ({ deps: { startUtc, endUtc }, context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED } }) => {
        dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED(setFilters({ startUtc, endUtc }));
    },
    component: Component,
    staticData: {
        routeName: RouteName.PayoutReportDetail,
        owner: MewsTeam.PaymentPayout,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { id } = Route.useParams();
    const guideLink = createGuideLink(ArticlePath.PayoutReport);

    return <PayoutReportDetail id={id} guideLink={guideLink} />;
}
